// extracted by mini-css-extract-plugin
export var pillWrapper = "_o3-0";
export var showOverflow = "_o3-1";